$(document).on('change', 'select.kix-country-check', function () {
    kixCountryCheck($(this));
});

window.kixCountryCheck = (inputElem) => {
    let kixInputsWrapper = $('#kix-inputs');
    let kix = inputElem.find('option:selected').first().data('kix')

    if (kix) {
        kixInputsWrapper.slideDown();
        kixInputsWrapper.find('input').prop('disabled', false)
        return;
    }

    kixInputsWrapper.slideUp();
    kixInputsWrapper.find('input').prop('disabled', true)
}
